<template>
  <v-dialog
    v-model="dialog"
    max-width="1000"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    @keydown.esc="$emit('update:opened', false)"
  >
    <v-card>
      <v-card-title class="d-flex top-bar">
        <sc-button-group class="d-flex justify-end">
          <sc-button
            type="secondary"
            @click="$emit('update:opened', false)"
            :is-round="true"
            icon-left="close"
            size="small"
          ></sc-button>
        </sc-button-group>
      </v-card-title>

      <v-card-text>
        <img :src="src" alt="image" style="width: 100%" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    opened: {
      type: Boolean,
    },

    src: {
      type: String,
    },
  },

  data() {
    return {
      dialog: this.opened,
    };
  },

  watch: {
    opened() {
      this.dialog = this.opened;
    },

    dialog() {
      this.$emit('update:opened', this.dialog);
    },
  },
};
</script>

<style>
.top-bar {
  position: sticky;
  top: 0;
  z-index: 1;
}
</style>
